import { Link, useLocation } from 'react-router-dom';
import ProjectBlockIcon from 'assets/project-logo-block.svg';
import { useGetMyInfoQuery } from 'src/hooks/useGetMyInfoQuery';
import { LoadingPage } from 'src/views/LoadingPage/LoadingPage';

import { SelectProjectTableContent } from './SelectProjectTableContent';
import { TableRow } from './TableRow';

import classes from './selectProjectPage.module.css';

export const SelectProjectPage = () => {
  const location = useLocation();
  const { data: myInfo, isLoading } = useGetMyInfoQuery();
  const projectRoles = myInfo?.projectRoles ?? {};
  const projectIds = Object.keys(projectRoles);
  // The project URL that sent the builder here, with `_` where the project goes (see ProjectProtectedPage).
  // Opened any other way (typed, bookmarked, after signing in again), it has none: go to the project's
  // dashboard.
  const from: string = location.state?.from ?? '/projects/_';

  if (isLoading) {
    return <LoadingPage variant="card" />;
  }

  return (
    <div style={{
      width: '100%', padding: '4rem 2rem', minHeight: '20rem', maxHeight: '80vh', overflowY: 'scroll',
    }}
    >
      <h1 className={`${classes.title} font-normal`}>Select a project to proceed</h1>

      <SelectProjectTableContent>
        {projectIds.map((projectId) => {
          const project = projectRoles[projectId];
          const newToUrl = from.replace('_', projectId);
          return (
            <TableRow key={projectId}>
              <Link to={newToUrl} className={classes.projectLink}>
                <img height="20px" src={ProjectBlockIcon} alt="project" className={classes.projectIcon} />
                <span className={classes.projectName}>{ project?.project.name }</span>
              </Link>
            </TableRow>
          );
        })}
      </SelectProjectTableContent>
    </div>
  );
};
